var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-drawer",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        title: "核销",
        visible: _vm.drawer,
        direction: "btt",
        size: "95%",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawer = $event
        },
      },
    },
    [
      _c("div", { staticClass: "view" }, [
        _c(
          "div",
          { staticClass: "water" },
          [
            _c(
              "el-tabs",
              {
                on: {
                  change: function ($event) {
                    _vm.waterSelectionRow = {}
                  },
                },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { label: "上传水单", name: "0" } },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "form",
                        staticClass: "formmain",
                        attrs: { model: _vm.form, rules: _vm.rules },
                      },
                      [
                        _c("div", { staticClass: "bank" }, [
                          _c("label", { staticClass: "label" }, [
                            _c("span", { staticClass: "red" }, [_vm._v("*")]),
                            _vm._v(" 收款账号"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "bank-select",
                              on: {
                                click: function ($event) {
                                  _vm.dialogVisible2 = true
                                },
                              },
                            },
                            [
                              !_vm.supplyItem.id
                                ? [
                                    _c("svg-icon", {
                                      attrs: {
                                        className: "icon1",
                                        iconClass: "add",
                                      },
                                    }),
                                    _c("span", { staticClass: "add" }, [
                                      _vm._v("选择账号"),
                                    ]),
                                  ]
                                : _vm._e(),
                              _vm.supplyItem.id
                                ? [
                                    _c("div", { staticClass: "panle" }, [
                                      _c(
                                        "div",
                                        { staticClass: "left" },
                                        [
                                          _c("svg-icon", {
                                            attrs: {
                                              className: "icon",
                                              iconClass:
                                                _vm.supplyItem.iconClass,
                                            },
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "content" },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "bank-name" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.supplyItem.bankName
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      class:
                                                        _vm.supplyItem.currency.toUpperCase(),
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.supplyItem.currency.toUpperCase()
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                { staticClass: "bank-name" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.supplyItem
                                                          .bankBranchName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                { staticClass: "bank-number" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.supplyItem
                                                          .accountNumber
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                { staticClass: "address" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.supplyItem.accountName
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "right" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "change-account",
                                            on: {
                                              click: function ($event) {
                                                _vm.dialogVisible2 = true
                                              },
                                            },
                                          },
                                          [_vm._v("更换账号")]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                        _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "付款账户名",
                                  prop: "paymentAccountName",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "320px" },
                                  attrs: { placeholder: "请输入付款账户名" },
                                  model: {
                                    value: _vm.form.paymentAccountName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "paymentAccountName",
                                        $$v
                                      )
                                    },
                                    expression: "form.paymentAccountName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "金额", prop: "sourceAmount" },
                              },
                              [
                                _c("el-input-number", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "controls-position": "right",
                                    min: 0.01,
                                    precision: 2,
                                  },
                                  on: { change: _vm.sourceAmountChange },
                                  model: {
                                    value: _vm.form.sourceAmount,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "sourceAmount", $$v)
                                    },
                                    expression: "form.sourceAmount",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "币制", prop: "sourceCurrency" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "320px" },
                                attrs: {
                                  placeholder: "请选择计算方式",
                                  disabled: "",
                                },
                                on: { change: _vm.currencyChange },
                                model: {
                                  value: _vm.form.sourceCurrency,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sourceCurrency", $$v)
                                  },
                                  expression: "form.sourceCurrency",
                                },
                              },
                              _vm._l(_vm.currencyOption, function (item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "汇率", prop: "exchangeRate" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "320px" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.form.exchangeRate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "exchangeRate", $$v)
                                },
                                expression: "form.exchangeRate",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "结算币制", prop: "realCurrency" },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "320px" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.form.realCurrency,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "realCurrency", $$v)
                                },
                                expression: "form.realCurrency",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "到账金额", prop: "realAmount" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "320px" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.form.realAmount,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "realAmount", $$v)
                                },
                                expression: "form.realAmount",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "到账日期", prop: "receiptOn" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "320px" },
                              attrs: {
                                type: "date",
                                placeholder: "选择日期",
                                "value-format": "yyyy-MM-dd",
                              },
                              model: {
                                value: _vm.form.receiptOn,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "receiptOn", $$v)
                                },
                                expression: "form.receiptOn",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "备注", prop: "description" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "320px" },
                              attrs: { placeholder: "请填写备注" },
                              model: {
                                value: _vm.form.description,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "description", $$v)
                                },
                                expression: "form.description",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "附件", prop: "systemFileId" } },
                          [
                            _c(
                              "div",
                              { staticClass: "view-upload" },
                              [
                                _c(
                                  "el-upload",
                                  {
                                    staticClass: "upload-demo",
                                    attrs: {
                                      drag: "",
                                      action: `/api/SystemFile/uploadFile?source=2`,
                                      headers: _vm.headers,
                                      multiple: false,
                                      "file-list": _vm.fileList,
                                      "show-file-list": false,
                                      data: { source: 2 },
                                      "on-success": _vm.handlesuccess,
                                      "on-error": _vm.onError,
                                      "on-progress": _vm.handlePreview,
                                      "on-remove": _vm.handleRemove,
                                      "on-exceed": _vm.handleExceed,
                                      limit: 1,
                                      "before-upload": _vm.beforeUpload,
                                    },
                                  },
                                  [
                                    _c("svg-icon", {
                                      attrs: {
                                        iconClass: "upload",
                                        className: "icon",
                                      },
                                    }),
                                    _c("div", { staticClass: "btn" }, [
                                      _vm._v("选择文件"),
                                    ]),
                                    _c(
                                      "p",
                                      { staticClass: "el-upload__text" },
                                      [_vm._v("只支持图片格式上传")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "file-list" },
                                  _vm._l(_vm.fileList, function (item, $index) {
                                    return _c(
                                      "div",
                                      { key: $index, staticClass: "panle" },
                                      [
                                        _c("div", { staticClass: "left" }, [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/images/const/constwiimg.png"),
                                              width: "32",
                                              height: "32",
                                            },
                                          }),
                                          _c("div", { staticClass: "file" }, [
                                            _c(
                                              "p",
                                              { staticClass: "file-name" },
                                              [_vm._v(_vm._s(item.name))]
                                            ),
                                            _c(
                                              "p",
                                              { staticClass: "file-size" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("formatterSize")(
                                                        item.size
                                                      )
                                                    ) +
                                                    " MB "
                                                ),
                                                _c("el-progress", {
                                                  staticStyle: {
                                                    width: "260px",
                                                    "margin-left": "20px",
                                                  },
                                                  attrs: {
                                                    width: 220,
                                                    percentage: _vm.percentage,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ]),
                                        _c("div", { staticClass: "right" }, [
                                          _c("i", {
                                            staticClass: "el-icon-delete gou",
                                            on: { click: _vm.removeFiles },
                                          }),
                                        ]),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  { attrs: { label: "选择水单", name: "1" } },
                  [
                    _vm.drawer
                      ? _c("BaseTable", {
                          attrs: {
                            height: 500,
                            tableData: {
                              ..._vm.tableDataByWaterBill,
                              fileds: _vm.fileds,
                            },
                            loading: _vm.loading,
                            isPager: false,
                            isEmptyBorder: true,
                          },
                          on: { handlerRadio: _vm.handlerRadio },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "companyId",
                                fn: function (row) {
                                  return [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatterCompany(
                                            row.scope.companyId
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "remainingVerifyAmount",
                                fn: function (row) {
                                  return [
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          color: "#304156",
                                          "font-weight": "bold",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              row.scope.remainingVerifyAmount ||
                                                0
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3458142314
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "check" }, [
          _c(
            "div",
            { staticClass: "header" },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v(_vm._s(!_vm.active ? "客户" : "代理")),
                    ]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.rowData.companyName || _vm.rowData.supplierName
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  !_vm.active
                    ? _c("el-col", { attrs: { span: 6 } }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("业务员"),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(" " + _vm._s(_vm.rowData.saleName)),
                        ]),
                      ])
                    : _vm._e(),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("账单总金额"),
                    ]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(" " + _vm._s(_vm.rowData.invoiceAmount)),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("已确认金额"),
                    ]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(" " + _vm._s(_vm.rowData.unverifyConfirmAmount)),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { "margin-top": "12px" } },
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("未确认金额"),
                    ]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(" " + _vm._s(_vm.rowData.unverifyUnConfirmAmount)),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("已核销金额"),
                    ]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(" " + _vm._s(_vm.rowData.verifedAmount)),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("账单未核销金额"),
                    ]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(
                        " " + _vm._s(_vm.rowData.unverifyInoviceAmountUnCk)
                      ),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("剩余可核销金额"),
                    ]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(
                        " " + _vm._s(_vm.rowData.remainingVerifiableAmount)
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { "margin-top": "12px" } },
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("最后核销日期"),
                    ]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(" " + _vm._s(_vm.rowData.lastVerifyDate) + " "),
                    ]),
                  ]),
                  _c(
                    "el-col",
                    { staticStyle: { display: "flex" }, attrs: { span: 12 } },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "label",
                          staticStyle: { "margin-top": "5px" },
                        },
                        [_vm._v("本次核销总金额")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "value",
                          staticStyle: { display: "flex" },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  size: "mini",
                                  min: 0,
                                  max: _vm.verifyAmountMax,
                                  placeholder: "请输入核销金额",
                                  "controls-position": "right",
                                },
                                on: { change: _vm.handleChange },
                                model: {
                                  value: _vm.verifyAmount,
                                  callback: function ($$v) {
                                    _vm.verifyAmount = $$v
                                  },
                                  expression: "verifyAmount",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content:
                                  "核销总金额默认=到账金额，核销总金额可以手动调整为不等于到账金额，差额部分为手续费退还到客户当前余额，即:手续费=到账金额-核销总金额",
                                placement: "bottom",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning-outline",
                                staticStyle: {
                                  color: "rgb(245, 108, 108)",
                                  "margin-top": "5px",
                                  "font-size": "20px",
                                  "margin-left": "8px",
                                  cursor: "pointer",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "data" },
            [
              _c("BaseTable", {
                ref: "baseTable",
                attrs: {
                  height: 320,
                  tableData: _vm.tableData,
                  loading: false,
                  isPager: false,
                  border: true,
                },
                on: { handleSelectionChange: _vm.handleSelectionChange },
                scopedSlots: _vm._u([
                  {
                    key: "unVerifedAmount",
                    fn: function (row) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.fomatterUnVerifedAmount(row.scope)) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "verifedAmountByNow",
                    fn: function (row) {
                      return [
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: row.scope.unVerifedAmount < 0,
                            size: "mini",
                            min:
                              row.scope.unVerifedAmount > 0
                                ? 0
                                : row.scope.unVerifedAmount,
                            max:
                              row.scope.unVerifedAmount > 0
                                ? _vm.verifyAmountMax >
                                  row.scope.unVerifedAmount
                                  ? row.scope.unVerifedAmount
                                  : _vm.verifyAmountMax
                                : 9999999,
                            placeholder: "请输入核销金额",
                            "controls-position": "right",
                          },
                          model: {
                            value: row.scope.verifedAmountByNow,
                            callback: function ($$v) {
                              _vm.$set(row.scope, "verifedAmountByNow", $$v)
                            },
                            expression: "row.scope.verifedAmountByNow",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("div", { staticClass: "select" }, [
                _c("p", [
                  _vm._v(" 总金额 "),
                  _c(
                    "span",
                    {
                      staticClass: "money",
                      staticStyle: { "margin-right": "10px" },
                    },
                    [_vm._v(_vm._s(_vm.sumAmount))]
                  ),
                  _vm._v(" 未核销金额 "),
                  _c("span", { staticClass: "money" }, [
                    _vm._v(_vm._s(_vm.sumUnVerifedAmount)),
                  ]),
                  _vm._v(" 本次核销金额 "),
                  _c("span", { staticClass: "money" }, [
                    _vm._v(" " + _vm._s(_vm.sunVerifedAmount) + " "),
                    _c(
                      "span",
                      {
                        staticClass: "money",
                        staticStyle: { "margin-left": "12px" },
                      },
                      [
                        _c("i", { staticClass: "el-icon-warning-outline" }),
                        _vm._v("本次总核销金额必须大于0"),
                      ]
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(" 总未核销金额 "),
                  _c("span", { staticClass: "money" }, [
                    _vm._v(" " + _vm._s(_vm.totalUnVerifedAmount) + " "),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "footer" }, [
        _c(
          "div",
          { staticClass: "cancel flex_c_c", on: { click: _vm.handleClose } },
          [_vm._v("取 消")]
        ),
        _c(
          "div",
          {
            staticClass: "ok flex_c_c",
            on: {
              click: function ($event) {
                return _vm.ok("form")
              },
            },
          },
          [_vm._v("确 定")]
        ),
      ]),
      _c("select-company-bank-dialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible2,
          companyId: _vm.rowData?.companyId,
          supplierId: _vm.rowData?.supplierId,
          typeActive: _vm.active,
        },
        on: { ok: _vm.ok2, cancel: _vm.cancel2 },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }